<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}">
						<h4 class="card-title"><mat-icon class="cursor-pointer" (click)="back()">arrow_back</mat-icon> 3rd Party Sales GL Report</h4>
					</div>
					<div class="card-body">
						<form [formGroup]="formGroup" *ngIf="formGroup">
							<div class="row">
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>From Date</mat-label>
										<input matInput [matDatepicker]="pickerFrom" formControlName="fromdate">
										<mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
										<mat-datepicker #pickerFrom></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>To Date</mat-label>
										<input matInput [matDatepicker]="pickerTo" formControlName="todate">
										<mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
										<mat-datepicker #pickerTo></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-md-12 mt-2">
									<button mat-raised-button color="accent" (click)="runReport()" [disabled]="loading">Run</button>
									<button mat-raised-button color="primary" class="ml-2" *ngIf="report?.rows?.length" (click)="exportExcel()">Export Excel</button>
									<button mat-raised-button class="ml-2" *ngIf="report?.rows?.length" (click)="exportPdf()" [disabled]="exporting"><i class="fa fa-file-pdf-o"></i> PDF</button>
								</div>
							</div>
						</form>

						<div class="row mt-3" *ngIf="loading">
							<div class="col-md-12 text-center">
								<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
									<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
								</svg>
							</div>
						</div>

						<div class="row mt-3" *ngIf="report && !loading">
							<div class="col-md-12">
								<div #print_table class="table-responsive" *ngIf="report.rows?.length">
									<table class="table table-striped table-sm">
										<thead>
											<tr>
												<th>Company Name</th>
												<th>Region</th>
												<th>No</th>
												<th>Name</th>
												<th>GL Account</th>
												<th>Document Type</th>
												<th>Posting Date</th>
												<th>Month</th>
												<th>Document</th>
												<th>Sales Order Number</th>
												<th>Name (Category)</th>
												<th class="text-right">Amount in USD</th>
												<th class="text-right">Amount in LCY</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let row of report.rows">
												<td>{{ row.company_name }}</td>
												<td>{{ row.region }}</td>
												<td>{{ row.source_no }}</td>
												<td>{{ row.customer_name }}</td>
												<td>{{ row.gl_account }}</td>
												<td>{{ row.document_type }}</td>
												<td>{{ row.posting_date }}</td>
												<td>{{ row.month_name }}</td>
												<td>{{ row.document_no }}</td>
												<td>{{ row.sales_order_number }}</td>
												<td>{{ row.name_category }}</td>
												<td class="text-right">{{ row.amount_usd | number:'1.2-2' }}</td>
												<td class="text-right">{{ row.amount_lcy | number:'1.2-2' }}</td>
											</tr>
											<tr class="font-weight-bold">
												<td colspan="11">Total</td>
												<td class="text-right">{{ report.totals.amount_usd | number:'1.2-2' }}</td>
												<td class="text-right">{{ report.totals.amount_lcy | number:'1.2-2' }}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<p *ngIf="report && (!report.rows || !report.rows.length)" class="text-muted">No data for the selected date range.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
